// extracted by mini-css-extract-plugin
module.exports = {"scrim":"StickyScrim_scrim__hiwtI","themed":"StickyScrim_themed__NXPxD"};